import React, { useEffect, useState } from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import pluralize from 'pluralize';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import LoadMask from '../../../../components/LoadMask';
import Popup from '../../../../components/Popup';
import ENDPOINT from '../../../../constants/endpoints';
import UxHelpers from '../../../../helpers/ux-helpers';
import useApi from '../../../../hooks/useApi';
import Dialog from '../../index';
import ResponseErrorDialog from '../ResponseErrorDialog';

const FollowUpEmailTemplateAssignedProcessesDialog = props => {
  const { show, proceed, dismiss, id } = props;

  useEffect(() => {
    api.get(
      ENDPOINT.OTHER.EMAIL_TEMPLATE_FOLLOWUP_ASSIGNED_PROCESSES,
      {
        id,
      },
      {
        handleError: response => {
          dismiss();
          ResponseErrorDialog({ response });
        },
        handleSuccess: response =>
          setBody(
            <Dialog>
              <div className="followup-email-template-assigned-processes-dialog">
                {renderProcessList(
                  response.filter(p => p.type === 'Job'),
                  'Processes'
                )}
                {renderProcessList(
                  response.filter(p => p.type === 'Project'),
                  'Projects'
                )}
              </div>
            </Dialog>
          ),
      }
    );
  }, []);

  const api = useApi();
  const [body, setBody] = useState();

  const proceedHandler = () => {
    proceed();
    UxHelpers.overflowLock('unlock');
  };

  const renderProcessList = (items, title) =>
    items.length > 0 ? (
      <div>
        <strong>{pluralize(title, items.length)}:</strong>
        <ul className="followup-email-template-assigned-processes-dialog__list">
          {items.map((item, i) => (
            <div
              className="followup-email-template-assigned-processes-dialog__list--item"
              key={i}
            >
              <a
                className="followup-email-template-assigned-processes-dialog__list--link"
                href={item.link}
                target="_blank"
              >
                {item.title}
              </a>
            </div>
          ))}
        </ul>
      </div>
    ) : null;

  return (
    show &&
    (body ? (
      <Popup
        actions={{
          dismiss,
        }}
        hasCloseButton={true}
        buttonsRender={
          <BasicButtonGroup
            groupStyles={{
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <BasicButton
              controlFunc={proceedHandler}
              btnWidth={200}
              btnHeight={40}
              btnFontWeight={500}
              btnArrow={false}
              btnTextColor="#27282d"
              btnText={'Ok'}
            />
          </BasicButtonGroup>
        }
        bodyRender={body}
        popupStyles={{
          padding: '30px',
        }}
      />
    ) : (
      <LoadMask />
    ))
  );
};

export default createConfirmation(
  confirmable(FollowUpEmailTemplateAssignedProcessesDialog)
);
